<template>
  <div class="OverlayLoading" :class="[`OverlayLoading--${type}`]">
    <Loading />
  </div>
</template>

<script lang="ts">
import Loading from '@spectee/components/Atoms/Loading/index.vue';
export default {
  name: 'OverlayLoading',
  components: { Loading },
  props: {
    type: {
      type: String,
      validator: function (value) {
        return ['default', 'modal'].indexOf(value as string) !== -1;
      },
      default: 'default',
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;
.OverlayLoading {
  position: fixed;
  left: 0;
  z-index: $service-z-index-ff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgb(255 255 255 / 40%);

  &--default {
    top: $service-unit * 12;
  }
  &--modal {
    top: 0;
  }
}
</style>
